import React, { useState } from "react";
import Select from "react-select";
import { useHistory } from "react-router-dom";

const options = [
  { value: "/daily-payment-receipt-mobile", label: "Daily Payment Reciept" },
  { value: "/daily-sales-mobile", label: "Daily Sales " },
  { value: "/daily-sales-return-mobile", label: "Daily Sales Return " },
  // {
  //   value: "/item-transaction-movement-mobile",
  //   label: "Transaction Movement Mobile",
  // },
  // { value: "/cheque-by-customer-mobile", label: "Cheque By Customer Mobile" },
  // { value: "/cheque-by-periodic-mobile", label: "Cheque By Periodic Mobile" },
  // { value: "/cheque-in-hand-mobile", label: "Cheque In Hand Mobile" },
  // { value: "/cheque-deposited-mobile", label: "Cheque Deposited Mobile" },
  // { value: "/cheque-realize-mobile", label: "Cheque Realised Mobile" },
  // { value: "/cheque-returned-mobile", label: "Cheque Return Mobile" },
  { value: "/cheque-by-salesRep-mobile", label: "Cheque Recipt by Rep " },
  { value: "/dashboard", label: "Back to main" },
];

function ReportsMobile() {
  const [selectedOption, setSelectedOption] = useState(null);
  const history = useHistory();

  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    if (selectedOption) {
      history.push(selectedOption.value);
    }
  };

  return (
    <div style={{ marginLeft: "", display: "flex", gap: 3 }}>
      <Select
        value={selectedOption}
        isSearchable={false}
        onChange={handleChange}
        options={options}
        placeholder="Reports(m)"
        styles={{
          control: (provided) => ({
            ...provided,
            backgroundColor: "#3e839c",
            color: "white",
            width: "120px",
            border: "none",
            boxShadow: "none",
          }),
          singleValue: (provided) => ({
            ...provided,
            color: "white",
          }),
          option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? "white" : "black",
            backgroundColor: state.isSelected ? "#3e839c" : "white",
          }),
          placeholder: (provided) => ({
            ...provided,
            color: "black", // Change this to your desired placeholder color
          }),
        }}
      />
    </div>
  );
}

export default ReportsMobile;
